<h2 class="property-header">Propriétés du déclencheur</h2>
<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field>
            <mat-label>Id</mat-label>
            <input matInput type="text" formControlName="id" autocomplete="off" tabindex="1" readonly="true" />
        </mat-form-field>
    </div>
    <div class="form-item form-item-help">
        <mat-form-field>
            <mat-label>Type de trigger</mat-label>
            <mat-select formControlName="type" tabindex="2" readonly="true">
                @for (triggerType of triggerTypes; track triggerType.value) {
                <mat-option [value]="triggerType.value">{{ triggerType.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</form>
<ng-template #dynamicContainer></ng-template>
